import React, { useEffect, useState } from 'react';
import 'react-dates/initialize';
import { ChevronLeftIcon, ChevronRightIcon } from '@root/styles/icons';
import { DayPickerRangeController } from 'react-dates';
import moment, { Moment } from 'moment';
import { useTranslations } from '@lang';
import { DateRangeInputs } from '../DateRangeInputs';
import { Messages } from '../Messages';
import { SingleMobileInput } from '../../DateInput/MobileInput/SingleMobileInput';
import { StyledMobileTextLabel } from '../../DateInput/MobileInput/SingleMobileInput/SingleMobileInput.styles';
import { MobilePickerWrapper, ControllerWrapper, CalendarInfoWrapper } from './MobileInput.styles';
import { CloseButton } from './CloseButton';
import { ResetDate } from '../ResetDate';
import { DateType } from '../DateRangeInput';
const MIN_STAY_DEFAULT = 1;

export const MobileInput = ({
  isSingle,
  startDate,
  endDate,
  handleDatesChange,
  extendedDay,
  dayIsUnavailable,
  dayIsHighlighted,
  getAvailability,
  currentSelectedDate,
  showMessage,
  setShowMessage,
  showNoAvailabilityMessage,
  handleDateChange,
  dateType,
  setDateType,
  handleOnClose,
  isHomepage,
}) => {
  const { t } = useTranslations();
  useEffect(() => {
    getAvailability(startDate);
  }, []);

  const [inputStartDate, setInputStartDate] = useState(moment(startDate));
  const [inputEndDate, setInputEndDate] = useState<Moment | null>(moment(endDate));
  const [keyProp, setKeyProp] = useState(moment(startDate).format('dd-mm-yyyy'));

  const handleUpdateDate = (dates) => {
    setInputStartDate(dates.startDate);
    handleDatesChange(dates);
    if (dates.endDate < dates.startDate) {
      setInputEndDate(null);
    }
    if (dates.endDate) {
      setInputEndDate(dates.endDate);
    }
  };

  const handleResetDate = (dates) => {
    handleUpdateDate(dates);
    setDateType('startDate');
    setKeyProp(dates.startDate);
  };

  return (
    <MobilePickerWrapper isHomepage={isHomepage}>
      <StyledMobileTextLabel htmlFor="date-range-start-date">
        {t('common.date')}
      </StyledMobileTextLabel>
      {isSingle ? (
        <SingleMobileInput onDateChange={handleDateChange} startDate={moment(startDate)} />
      ) : (
        <>
          <DateRangeInputs
            endDate={endDate}
            onClick={() => {
              if (dateType) setDateType(DateType.NONE);
              else
                handleResetDate({
                  startDate: inputStartDate ?? moment(),
                  endDate: inputEndDate ?? null,
                });
            }}
            inputStartDate={inputStartDate}
          />
          {dateType ? (
            <ControllerWrapper isHomepage={isHomepage}>
              <DayPickerRangeController
                key={keyProp}
                initialVisibleMonth={null}
                orientation="vertical"
                startDate={inputStartDate}
                endDate={inputEndDate}
                onDatesChange={handleUpdateDate}
                focusedInput={dateType}
                onFocusChange={(ele) => {
                  getAvailability(startDate);
                  setDateType(ele);
                }}
                renderDayContents={extendedDay}
                isDayBlocked={dayIsUnavailable}
                isDayHighlighted={dayIsHighlighted}
                onNextMonthClick={getAvailability}
                onPrevMonthClick={getAvailability}
                renderCalendarInfo={() => (
                  <>
                    <CloseButton setClose={() => setDateType(DateType.NONE)} />
                    <CalendarInfoWrapper>
                      <Messages
                        currentSelectedDate={currentSelectedDate}
                        showMessage={showMessage}
                        setShowMessage={setShowMessage}
                        showNoAvailabilityMessage={showNoAvailabilityMessage}
                      />
                      <ResetDate handleResetDate={handleResetDate} />
                    </CalendarInfoWrapper>
                  </>
                )}
                calendarInfoPosition={showNoAvailabilityMessage ? 'top' : 'bottom'}
                hideKeyboardShortcutsPanel
                navNext={<ChevronRightIcon />}
                navPrev={<ChevronLeftIcon />}
                daySize={50}
                onClose={handleOnClose}
                numberOfMonths={1}
                transitionDuration={0}
                minDate={moment()}
                minimumNights={currentSelectedDate?.minimumStay || MIN_STAY_DEFAULT}
              />
            </ControllerWrapper>
          ) : null}
        </>
      )}
    </MobilePickerWrapper>
  );
};
